module.exports = __webpack_public_path__ + "static/media/personalInstruction.ffd24cfd.png";